var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05835 8.87027C4.391 4.58452 8.38843 1.47266 13.1127 1.47266C17.8369 1.47266 21.8343 4.58452 23.167 8.87027M23.167 8.87027L19.5145 7.73218M23.167 8.87027L24.3514 5.31373",
    stroke: "#4F4E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2134 15.1297C21.8807 19.4155 17.8833 22.5273 13.1591 22.5273C8.43481 22.5273 4.43738 19.4155 3.10473 15.1297M3.10473 15.1297L6.75727 16.2678M3.10473 15.1297L1.92036 18.6863",
    stroke: "#4F4E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResubmission);
export default __webpack_public_path__ + "static/media/Resubmission.8a135d62e0274cf42e5262b25323683f.svg";
export { ForwardRef as ReactComponent };